import { json } from '@remix-run/node'
import { useOutletContext } from '@remix-run/react'
import { UserContext } from '~/routes/_front.users.$id'
import { MarkdownContents } from '~/application/components/MarkdownContents/MarkdownContents'

export async function loader() {
  return json({})
}

export default function UserDetail() {
  const context = useOutletContext<Required<UserContext>>()

  return (
    <div>
      <MarkdownContents markdown={context.user.description} />
    </div>
  )
}
